export const LIST_BRANCH_PRICE_CATEGORY_REQUEST =
  'LIST_BRANCH_PRICE_CATEGORY_REQUEST'
export const LIST_BRANCH_PRICE_CATEGORY_SUCCESS =
  'LIST_BRANCH_PRICE_CATEGORY_SUCCESS'
export const LIST_BRANCH_PRICE_CATEGORY_FAIL = 'LIST_BRANCH_PRICE_CATEGORY_FAIL'

export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_REQUEST =
  'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_REQUEST'
export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_SUCCESS =
  'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_SUCCESS'
export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL =
  'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL'

export const CREATE_BRANCH_PRICE_CATEGORY_REQUEST =
  'CREATE_BRANCH_PRICE_CATEGORY_REQUEST'
export const CREATE_BRANCH_PRICE_CATEGORY_SUCCESS =
  'CREATE_BRANCH_PRICE_CATEGORY_SUCCESS'
export const CREATE_BRANCH_PRICE_CATEGORY_FAIL =
  'CREATE_BRANCH_PRICE_CATEGORY_FAIL'

export const DETAIL_BRANCH_PRICE_CATEGORY_REQUEST =
  'DETAIL_BRANCH_PRICE_CATEGORY_REQUEST'
export const DETAIL_BRANCH_PRICE_CATEGORY_SUCCESS =
  'DETAIL_BRANCH_PRICE_CATEGORY_SUCCESS'
export const DETAIL_BRANCH_PRICE_CATEGORY_FAIL =
  'DETAIL_BRANCH_PRICE_CATEGORY_FAIL'

export const UPDATE_BRANCH_PRICE_CATEGORY_REQUEST =
  'UPDATE_BRANCH_PRICE_CATEGORY_REQUEST'
export const UPDATE_BRANCH_PRICE_CATEGORY_SUCCESS =
  'UPDATE_BRANCH_PRICE_CATEGORY_SUCCESS'
export const UPDATE_BRANCH_PRICE_CATEGORY_FAIL =
  'UPDATE_BRANCH_PRICE_CATEGORY_FAIL'

export const DELETE_BRANCH_PRICE_CATEGORY_REQUEST =
  'DELETE_BRANCH_PRICE_CATEGORY_REQUEST'
export const DELETE_BRANCH_PRICE_CATEGORY_SUCCESS =
  'DELETE_BRANCH_PRICE_CATEGORY_SUCCESS'
export const DELETE_BRANCH_PRICE_CATEGORY_FAIL =
  'DELETE_BRANCH_PRICE_CATEGORY_FAIL'

// export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL = 'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL'
// export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL = 'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL'
// export const LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL = 'LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL'

export const RESET_BRANCH_PRICE_CATEGORY = 'RESET_BRANCH_PRICE_CATEGORY'
